export type OnboardingHeaderSlot = 'pending' | 'header' | 'menu';

/**
 * Resolve where onboarding reopen lives in the header.
 * While app config is unsettled, keep the slot empty so HelpCircle does not
 * flash before Progress & Trophies replaces it.
 */
export function resolveOnboardingHeaderSlot(
  isAuthenticated: boolean,
  gamificationEnabled: boolean,
  configReady: boolean,
): OnboardingHeaderSlot {
  if (!isAuthenticated || !configReady) {
    return 'pending';
  }
  return gamificationEnabled ? 'menu' : 'header';
}
